const CELL_TYPES = {
  servicer: 'servicer',
  information: 'information',
};

Object.freeze(CELL_TYPES);

export { CELL_TYPES };
